<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">الدارسين المسجلين</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>

        <!-- Search and Filter Section -->
        <div class="mt-4 mb-6">
            <div class="flex flex-col gap-4">
                <div class="flex flex-col sm:flex-row gap-4">
                    <div class="flex-1">
                        <input
                            v-model="searchQuery"
                            @keyup.enter="handleSearch"
                            type="text"
                            placeholder="البحث بالاسم، الجوال، البريد الإلكتروني، أو الهوية..."
                            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                    <div class="flex gap-2">
                        <button
                            @click="handleSearch"
                            class="px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor/90"
                        >
                            بحث
                        </button>
                        <button
                            @click="clearSearch"
                            class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        >
                            مسح البحث
                        </button>
                        <button
                            @click="openExportModal"
                            :disabled="loading || totalElements === 0"
                            class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            تصدير
                        </button>
                    </div>
                </div>
                <!-- Filter Section -->
                <div class="flex flex-col sm:flex-row gap-4 items-center">
                    <div class="flex items-center gap-2">
                        <label class="text-sm font-medium text-gray-700">حالة التفعيل:</label>
                        <select
                            v-model="isDeactivatedFilter"
                            @change="handleFilterChange"
                            class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="-1">الكل</option>
                            <option value="0">المفعلين فقط</option>
                            <option value="1">غير المفعلين فقط</option>
                        </select>
                    </div>
                    <div class="flex items-center gap-2">
                        <label class="text-sm font-medium text-gray-700">نوع الطالب:</label>
                        <select
                            v-model="isNewFilter"
                            @change="handleFilterChange"
                            class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                            <option value="-1">الجميع</option>
                            <option value="0">المسجلين فقط</option>
                            <option value="1">الجدد فقط</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-8 flex flex-col">
            <div class="sm:flex-auto">
                <h1 class="text-lg font-medium text-gray-900"> الحسابات المسجلة</h1>
                <p class="mt-2 text-xs text-gray-700">
                    عرض {{ students.length }} من أصل {{ totalElements }} دارس
                    (الصفحة {{ currentPage + 1 }} من {{ totalPages }})
                </p>
            </div>

            <!-- Loading indicator -->
            <div v-if="loading" class="text-center py-8">
                <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-customHafadhColor"></div>
                <p class="mt-2 text-gray-600">جارٍ التحميل...</p>
            </div>

            <div v-else-if="!this.errorMessageStatus" class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                    <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table class="min-w-full divide-y divide-customHafadhColor">
                            <thead class="bg-customHafadhColor text-center">
                                <tr>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الاسم
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الجوال
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الهوية
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        المسار
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        حالة الدارس
                                    </th>
                                    <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">
                                        الإجراءات
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white">
                                <tr v-for=" (student, index) in students" :key="student.id">
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        {{ student.fullName }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.phone }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.nationalId || '-' }}
                                    </td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                        {{ student.massaratValue }}
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        <Switch @click="onClickStatusOfStudent(index, !student.isEnabled)"
                                            v-model="student.isEnabled" :class="[
                student.isEnabled ? 'bg-blue-600' : 'bg-gray-200',
                'mr-2 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
            ]">
                                            <span class="sr-only"></span>
                                            <span :class="[
                student.isEnabled ? '-translate-x-5' : 'translate-x-0',
                'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
            ]">
                                                <span :class="[
                student.isEnabled
                    ? 'opacity-0 ease-out duration-100'
                    : 'opacity-100 ease-in duration-200',
                'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
            ]" aria-hidden="true">
                                                    <svg class="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                                <span :class="[
                student.isEnabled
                    ? 'opacity-100 ease-in duration-200'
                    : 'opacity-0 ease-out duration-100',
                'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity',
            ]" aria-hidden="true">
                                                    <svg class="h-3 w-3 text-blue-600" fill="currentColor"
                                                        viewBox="0 0 12 12">
                                                        <path
                                                            d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </Switch>
                                    </td>
                                    <td
                                        class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900 sm:pr-6">
                                        <button class="enabled-button px-3 py-1 text-sm" @click="openStudentDetailsModal(index)">
                                            تفاصيل
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Pagination -->
                <div class="mt-6 flex items-center justify-between">
                    <div class="flex-1 flex justify-between sm:hidden">
                        <button
                            @click="previousPage"
                            :disabled="currentPage === 0 || loading"
                            class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            السابق
                        </button>
                        <button
                            @click="nextPage"
                            :disabled="!hasNext || loading"
                            class="mr-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            التالي
                        </button>
                    </div>
                    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                        <div>
                            <p class="text-sm text-gray-700">
                                عرض <span class="font-medium">{{ startIndex + 1 }}</span> إلى <span class="font-medium">{{ endIndex }}</span>
                                من أصل <span class="font-medium">{{ totalElements }}</span> نتيجة
                            </p>
                        </div>
                        <div>
                            <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                                <button
                                    @click="previousPage"
                                    :disabled="currentPage === 0 || loading"
                                    class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <span class="sr-only">السابق</span>
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                                
                                <button
                                    v-for="page in visiblePages"
                                    :key="page"
                                    @click="goToPage(page)"
                                    :class="[
                                        page === currentPage + 1
                                            ? 'z-10 bg-customHafadhColor border-customHafadhColor text-white'
                                            : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50',
                                        'relative inline-flex items-center px-4 py-2 border text-sm font-medium'
                                    ]"
                                >
                                    {{ page }}
                                </button>
                                
                                <button
                                    @click="nextPage"
                                    :disabled="!hasNext || loading"
                                    class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <span class="sr-only">التالي</span>
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="this.errorMessageStatus">
                <h1 style="color: red;"> {{ this.errorMessage }}</h1>
            </div>
        </div>

        <!-- Password Popup -->
        <div v-if="showPopupPassword" class="popup" dir="rtl">
            <div class="popup-content">
                <h3 class="text-lg leading-6 font-medium text-gray-900">تغيير الرقم السري</h3>
                <div class="col-span-6 sm:col-span-3 mt-10">
                    <label for="password" class="block text-sm font-medium text-gray-700">
                        كلمة المرور
                    </label>
                    <input name="password" id="password" v-model="password" placeholder="الرقم السري"
                        class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')"
                        oninput="setCustomValidity('')" :type="showPassword ? 'text' : 'password'"
                        @input="validatePassword" />
                    <span v-if="passwordError" class="text-center text-red-500 text-xs">{{ passwordError }}</span>
                </div>
                <div class="col-span-6 sm:col-span-3 mt-5">
                    <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
                        اعادة ادخال كلمة المرور
                    </label>
                    <input name="confirmPassword" id="confirmPassword" v-model="confirmPassword"
                        placeholder="الرقم السري"
                        class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')"
                        oninput="setCustomValidity('')" :type="showPassword ? 'text' : 'password'"
                        @input="validatePassword" />
                    <span v-if="confirmPasswordError" class="text-center text-red-500 text-xs">{{ confirmPasswordError
                        }}</span>
                </div>
                <div class="block text-sm font-medium text-gray-700 mt-5 mr-2">
                    <input type="checkbox" v-model="showPassword" />
                    عرض كلمة المرور
                </div>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                    <button
                        class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                        @click="submitPassword()" type="submit" :disabled="passwordSuccess"
                        :class="{ 'cursor-not-allowed': passwordSuccess }">تم</button>
                    <button
                        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                        @click="closePopup" type="button">الغاء</button>
                </div>
            </div>
        </div>

        <!-- Change Detiles Popup -->
    <div v-if="showEditModal" class="popup" dir="rtl">
      <div class="popup-content">
        <h3>تغيير بيانات الدارس</h3>
        <div>
          <label>الاسم الكامل</label>
          <input v-model="editStudent.fullName" type="text" class="w-full p-2 border rounded" />
        </div>
        <div>
          <label>الايميل</label>
          <input v-model="editStudent.email" type="email" class="w-full p-2 border rounded" />
        </div>
        <div>
          <label>الجوال</label>
          <input v-model="editStudent.phone" type="text" class="w-full p-2 border rounded" maxlength="16" />
        </div>
        <div>
          <label>رقم الهوية</label>
          <input
            v-model="editStudent.nationalId"
            type="text"
            class="w-full p-2 border rounded"
            maxlength="10"
            placeholder="10 أرقام"
          />
        </div>
        <div>
          <label>المسار</label>
          <select
           v-model.number="editStudent.massaratId"
           class="w-full p-2 border rounded">
           <option disabled value="">الرجاء اختيار المسار</option>
        <option
          v-for="m in massarats"
          :key="m.id"
          :value="m.id">
          {{ m.value.trim() }}
        </option>
         </select>
        </div> 
        <div>
        <label>مدة الاشتراك</label>
        <select v-model.number="editStudent.user_preference" class="w-full p-2 border rounded">
          <!-- MARK: bind to user_preference instead of engagementPreference -->
          <option disabled value="">الرجاء اختيار الاشتراك</option>
          <option v-for="d in durations" :key="d.id" :value="d.id">
            {{ d.durationDesc }}
          </option>
        </select>
      </div>
        <div>
          <label>التعليم</label>
          <select v-model="editStudent.qualificationId" class="w-full p-2 border rounded">
            <option v-for="q in qualifications" :key="q.id" :value="q.id">{{ q.qualificationValue }}</option>
          </select>
        </div>
        <div class="mt-6 grid grid-cols-2 gap-3">
         <button class="enabled-button w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
         @click="submitDetiles()"
         >حفظ</button>
          <button class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
          @click="closePopup()"
          >الغاء</button>
        </div>
      </div>
    </div>

    <!-- Student Details Modal -->
    <div v-if="showStudentDetailsModal" class="popup" dir="rtl">
        <div class="popup-content" style="width: 600px; max-height: 80vh; overflow-y: auto;">
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-lg leading-6 font-medium text-gray-900">تفاصيل الدارس</h3>
                <button @click="closeStudentDetailsModal" class="text-gray-400 hover:text-gray-600">
                    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            
            <div v-if="selectedStudent" class="grid grid-cols-1 gap-4">
                <div class="bg-gray-50 p-4 rounded-lg">
                    <h4 class="font-semibold text-gray-700 mb-3">المعلومات الأساسية</h4>
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-600">الاسم الكامل</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.fullName }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">الايميل</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.email }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">رقم الجوال</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.phone }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">العمر</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.age || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">تاريخ ووقت التسجيل</label>
                            <p class="mt-1 text-sm text-gray-900">{{ formatDate(selectedStudent.createdDate) }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">رقم الهوية</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.nationalId || '-' }}</p>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-50 p-4 rounded-lg">
                    <h4 class="font-semibold text-gray-700 mb-3">معلومات الدراسة</h4>
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-600">المسار</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.massaratValue || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">مدة الاشتراك</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.engagementPreference || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">المؤهل التعليمي</label>
                            <p class="mt-1 text-sm text-gray-900">{{ selectedStudent.qualificationValue || '-' }}</p>
                        </div>
                        <div>
                            <label class="block text-sm font-medium text-gray-600">حالة الدارس</label>
                            <p class="mt-1 text-sm">
                                <span :class="selectedStudent.isEnabled ? 'text-green-600' : 'text-red-600'">
                                    {{ selectedStudent.isEnabled ? 'نشط' : 'غير نشط' }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-50 p-4 rounded-lg">
                    <h4 class="font-semibold text-gray-700 mb-3">أجزاء القرآن</h4>
                    <div v-if="selectedStudent.quranParts && selectedStudent.quranParts.length > 0" class="space-y-2">
                        <button
                            @click="openQuranPartsModal(selectedStudent)"
                            class="text-customHafadhColor hover:text-customHafadhColorHover underline font-medium text-sm">
                            عرض الأجزاء ({{ selectedStudent.quranParts.length }})
                        </button>
                    </div>
                    <p v-else class="text-sm text-gray-500">لا توجد أجزاء مسجلة</p>
                </div>

                <div class="flex justify-end gap-3 mt-6">
                    <button
                        @click="openEditModalFromDetails"
                        class="enabled-button px-4 py-2"
                    >
                        تعديل البيانات
                    </button>
                    <button
                        @click="openPasswordModalFromDetails"
                        class="enabled-button px-4 py-2"
                    >
                        تغيير كلمة المرور
                    </button>
                    <button
                        @click="closeStudentDetailsModal"
                        class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Quran Parts Modal -->
    <div v-if="showQuranPartsModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <!-- Background overlay -->
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeQuranPartsModal"></div>

            <!-- Modal panel -->
            <div class="inline-block align-bottom bg-white rounded-lg text-right overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div class="sm:flex sm:items-start">
                        <div class="mt-3 text-center sm:mt-0 sm:text-right w-full">
                            <h3 class="text-lg leading-6 font-medium text-gray-900 mb-4" id="modal-title">
                                أجزاء القرآن - {{ selectedStudentName }}
                            </h3>
                            <div class="mt-2">
                                <div v-if="selectedStudentQuranParts && selectedStudentQuranParts.length > 0" class="space-y-2">
                                    <div
                                        v-for="(part, index) in selectedStudentQuranParts"
                                        :key="part.id || index"
                                        class="p-3 bg-gray-50 rounded-lg border border-gray-200">
                                        <p class="text-sm font-medium text-gray-900">
                                            {{ part.description || `جزء ${part.id}` }}
                                        </p>
                                    </div>
                                </div>
                                <p v-else class="text-sm text-gray-500">لا توجد أجزاء مسجلة</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button
                        type="button"
                        @click="closeQuranPartsModal"
                        class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-customHafadhColor text-base font-medium text-white hover:bg-customHafadhColorHover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-customHafadhColor sm:ml-3 sm:w-auto sm:text-sm">
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Export Modal -->
    <div v-if="showExportModal" class="popup" dir="rtl">
        <div class="popup-content text-right" style="width: 640px; max-width: 92vw; max-height: 85vh; overflow-y: auto;">
            <h3 class="text-lg font-medium text-gray-900 mb-4 text-right">تصدير بيانات الدارسين</h3>

            <!-- Scope -->
            <div class="mb-5">
                <p class="text-sm font-medium text-gray-700 mb-2">نطاق التصدير</p>
                <label class="flex items-center gap-2 text-sm text-gray-700 mb-1">
                    <input type="radio" value="filtered" v-model="exportScope" :disabled="exporting" />
                    كل النتائج المطابقة للفلاتر ({{ totalElements }} دارس)
                </label>
                <label class="flex items-center gap-2 text-sm text-gray-700">
                    <input type="radio" value="page" v-model="exportScope" :disabled="exporting" />
                    الصفحة الحالية فقط ({{ students.length }} دارس)
                </label>
            </div>

            <!-- Fields -->
            <div class="mb-4">
                <div class="flex items-center justify-between mb-2">
                    <p class="text-sm font-medium text-gray-700">البيانات المطلوب تصديرها</p>
                    <div class="flex gap-3">
                        <button type="button" @click="selectAllExportFields" :disabled="exporting"
                            class="text-xs text-customHafadhColor hover:underline disabled:opacity-50">
                            تحديد الكل
                        </button>
                        <button type="button" @click="clearExportFields" :disabled="exporting"
                            class="text-xs text-gray-500 hover:underline disabled:opacity-50">
                            إلغاء التحديد
                        </button>
                    </div>
                </div>
                <div class="grid grid-cols-2 sm:grid-cols-3 gap-2 border border-gray-200 rounded p-3">
                    <label v-for="field in exportFields" :key="field.key"
                        class="flex items-center gap-2 text-sm text-gray-700">
                        <input type="checkbox" :value="field.key" v-model="exportSelectedFields" :disabled="exporting" />
                        {{ field.label }}
                    </label>
                </div>
            </div>

            <!-- Feedback -->
            <p v-if="exportError" class="text-sm text-red-600 mb-3">{{ exportError }}</p>
            <p v-if="exporting" class="text-sm text-gray-600 mb-3">
                جارٍ التحضير... ({{ exportProgress.done }} من {{ exportProgress.total }})
            </p>

            <!-- Footer -->
            <div class="sm:flex sm:flex-row-reverse gap-3 mt-6">
                <button
                    type="button"
                    @click="runExport"
                    :disabled="exporting"
                    class="px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor/90 disabled:opacity-50 disabled:cursor-not-allowed">
                    تصدير
                </button>
                <button
                    type="button"
                    @click="closeExportModal"
                    :disabled="exporting"
                    class="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed">
                    إلغاء
                </button>
            </div>
        </div>
    </div>

</div>
</template>


<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';

// Single source of truth for the export field picker: drives the checkbox list,
// the column order in the sheet, and how each cell value is produced.
const EXPORT_FIELDS = [
    { key: 'fullName',             label: 'الاسم الكامل',      default: true,  value: s => s.fullName || '' },
    { key: 'phone',                label: 'رقم الجوال',        default: true,  value: s => (s.phone ? String(s.phone) : '') },
    { key: 'nationalId',           label: 'رقم الهوية',        default: true,  value: s => (s.nationalId ? String(s.nationalId) : '') },
    { key: 'email',                label: 'البريد الإلكتروني', default: true,  value: s => s.email || '' },
    { key: 'age',                  label: 'العمر',             default: false, value: s => (s.age ?? '') },
    { key: 'massaratValue',        label: 'المسار',            default: true,  value: s => s.massaratValue || '' },
    { key: 'engagementPreference', label: 'مدة الاشتراك',      default: false, value: s => s.engagementPreference || '' },
    { key: 'qualificationValue',   label: 'المؤهل التعليمي',   default: false, value: s => s.qualificationValue || '' },
    { key: 'isEnabled',            label: 'حالة التفعيل',      default: true,  value: s => (s.isEnabled ? 'مفعل' : 'غير مفعل') },
    { key: 'statusLabel',          label: 'حالة القبول',       default: false, value: s => s.statusLabel || '' },
    { key: 'canWithdraw',          label: 'حالة الانسحاب',     default: false, value: s => (s.canWithdraw ? 'نعم' : 'لا') },
    { key: 'quranParts',           label: 'أجزاء القرآن',      default: false, value: s => (s.quranParts || []).map(p => p.description || `جزء ${p.id}`).join('، ') },
    { key: 'createdDate',          label: 'تاريخ التسجيل',     default: false, value: s => s.createdDate || '' },
    { key: 'appVersion',           label: 'نسخة التطبيق',      default: false, value: s => s.appVersion || '' },
    { key: 'appPlatform',          label: 'منصة التطبيق',      default: false, value: s => s.appPlatform || '' },
];

class masterSessionsDto {
    constructor(data) {
        this.id = data.id || null;
        this.sessionsId = data.sessionsId || null;
        this.sessionsName = data.sessionsName || null;
    }
}

class StudentDto {
    constructor(data) {
     this.id = data.id;
     this.fullName = data.fullName;
     this.email = data.email;
     this.phone = data.phone;
     this.age = data.age || null;
     this.engagementPreference = data.engagementPreference;
     this.qualificationId      = data.qualificationId;
     this.user_preference = data.user_preference;
     this.qualificationValue   = data.qualificationValue;
     this.massaratId           = data.massaratId;
     this.massaratValue        = data.massaratValue;
     this.quranParts = data.quranParts || [];
     this.createdDate = data.createdDate || null;
     this.nationalId           = data.nationalId || null;
     this.canWithdraw          = data.canWithdraw;
     this.isEnabled            = data.isEnabled;
     this.statusLabel          = data.statusLabel || '';
     this.appVersion           = data.appVersion || '';
     this.appPlatform          = data.appPlatform || '';
   }
}
export default defineComponent({
    data() {
        return {
            students: [],
            showPopupPassword: false,
            password: '',
            confirmPassword: '',
            userIndex: '',
            showPassword: false,
            passwordError: '',
            passwordSuccess: true,
            confirmPasswordError: '',
            sessionsId: '',
            masterSessionValue: "",
            masterSessionsList: [],
            errorMessage: "عذرا لا يوجد للدارسين مسجلين مع المعلم ",
            errorMessageStatus: false,
            emailError: "",
            showEditModal: false,
            editIndex: null,
            editStudent: {
              id: null,
              fullName: '',
              email: '',
              phone: '',
              massaratId: null,
              engagementPreference: '',
              qualificationId: null,
              user_preference: null,
              nationalId: '',
            },
          // lookup lists
          durations: [],            // engagementPreference options
          qualifications: [],
          massarats: [],
          searchQuery: '',
          isDeactivatedFilter: '0', // -1 = all, 0 = enabled only, 1 = disabled only
          isNewFilter: '0', // -1 = all, 0 = registered only, 1 = new only
          currentPage: 0,
          totalElements: 0,
          totalPages: 0,
          startIndex: 0,
          endIndex: 0,
          visiblePages: [],
          loading: false,
          hasNext: true,
          showStudentDetailsModal: false,
          selectedStudent: null,
          selectedStudentIndex: null,
          showQuranPartsModal: false,
          selectedStudentQuranParts: [],
          selectedStudentName: '',
          // Export
          showExportModal: false,
          exportScope: 'filtered',    // 'filtered' = every row matching current filters, 'page' = visible page only
          exportSelectedFields: [],
          exportError: '',
          exporting: false,
          exportProgress: { done: 0, total: 0 },
        }
    },
    computed: {
        exportFields() {
            return EXPORT_FIELDS;
        },
    },
    mounted() {
        this.getMasterSessions();
        this.loadLookups(); 
    },
    methods: {
        async getAllNewStudents() {
            this.loading = true;
            try {
                const params = {
                    isNew: this.isNewFilter,
                    isDeactivated: this.isDeactivatedFilter,
                    sessionId: null,
                    page: this.currentPage,
                    size: 20,
                };
                
                // Only add search parameter if it's not empty
                if (this.searchQuery && this.searchQuery.trim() !== '') {
                    params.search = this.searchQuery.trim();
                }
                
                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students,
                    {
                        params: params,
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                
                const responseData = response.data.result.data;
                this.students = responseData.content.map(studentData => new StudentDto(studentData));
                this.totalElements = responseData.totalElements;
                this.totalPages = responseData.totalPages;
                this.hasNext = responseData.hasNext;
                
                // Calculate pagination display info
                this.startIndex = this.currentPage * 20;
                this.endIndex = Math.min(this.startIndex + this.students.length, this.totalElements);
                this.updateVisiblePages();
                
                this.errorMessageStatus = false;
            } catch (error) {
                this.errorMessageStatus = true;
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        async loadLookups() {
          const headers = { 'X-Authorization': localStorage.getItem('token') };
          
          // Get tenant_id from JWT token
          let tenantId = null;
          try {
            const token = localStorage.getItem('token');
            if (token) {
              const payload = JSON.parse(atob(token.split('.')[1]));
              tenantId = payload.tenantId || payload.tenant_id || null;
            }
          } catch (e) {
            console.warn('Could not extract tenantId from token:', e);
          }

          // Build URLs with tenantId as query parameter
          let durationsUrl = url.master_durations;
          let qualificationsUrl = url.master_qualifications;
          let massaratsUrl = url.master_massarats;
          
          if (tenantId) {
            const tenantParam = `?tenantId=${encodeURIComponent(tenantId)}`;
            durationsUrl += tenantParam;
            qualificationsUrl += tenantParam;
            massaratsUrl += tenantParam;
          }

          try {
            // give each response a clear name
            const [durRes, qualRes, massaRes] = await Promise.all([
              axios.get(`${process.env.VUE_APP_SERVICE_URL}${durationsUrl}`,  { headers }),
              axios.get(`${process.env.VUE_APP_SERVICE_URL}${qualificationsUrl}`, { headers }),
              axios.get(`${process.env.VUE_APP_SERVICE_URL}${massaratsUrl}`,    { headers }),
            ]);
        
            //console.log('durations payload:', durRes);
            //console.log('qualifications payload:', qualRes);
            //console.log('massarats payload:', massaRes);
        
            // now safely assign
            this.durations      = durRes.data?.result?.data  ?? [];
            this.qualifications = qualRes.data?.result?.data ?? [];
            this.massarats      = massaRes.data?.result?.data ?? [];
            //console.log("massarats lookup:", this.massarats);
            //console.log("durations lookup:", this.durations);

            if (!Array.isArray(this.massarats)) {
              console.warn('massarats is not an array!', this.massarats);
            

            }
          } catch (err) {
            console.error('Error loading lookups:', err.response || err);
            alert('فشل جلب بيانات المسارات. تأكد من اتصال الإنترنت أو صلاحية الـ URL.');
          }
        },
        async onClickStatusOfCanWithdraw(index, statusOfCanWithdraw) {
            let studentId = this.students[index].id;
            let status = statusOfCanWithdraw ? "1" : "0";

            try {
                const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.withdrawalStatus + studentId + "?enable=" + status,
                    {},
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                if (response.status == 200) {
                    this.students[index].canWithdraw = statusOfCanWithdraw
                }
            } catch (error) {
                console.error(error);
            }

        },
        async onClickStatusOfStudent(index, isEnabled) {
            let studentId = this.students[index].id;
            let status = isEnabled ? "1" : "0";

            try {
                const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.userStatus + studentId + "?enable=" + status,
                    {},
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                if (response.status == 200) {
                    this.students[index].isEnabled = isEnabled
                }
            } catch (error) {
                console.error(error);
            }

        },

        openPopupPassword(index) {
            this.showPopupPassword = true;
            this.passwordSuccess = true;
            this.password = '';
            this.confirmPassword = '';
            this.userIndex = index;
        },
        openEditModal(index) {
          this.editIndex = index;
          const s = this.students[index];
          this.editStudent = {
            id:                   s.id,
            fullName:             s.fullName,
            email:                s.email,
            phone:                s.phone,
            massaratId:           s.massaratId,
            engagementPreference: s.engagementPreference,
            user_preference:       s.user_preference,
            qualificationId:      s.qualificationId,
            nationalId:           s.nationalId || '',
          };
          this.showEditModal = true;
        },
        closePopup() {
            this.showPopupPassword = false;
            this.showEditModal = false;
            this.showStudentDetailsModal = false;
            this.password = '';
            this.confirmPassword = '';
            this.selectedStudent = null;
            this.selectedStudentIndex = null;
        },
        async submitPassword() {
            if (this.password !== this.confirmPassword) {
                //todo here need to check 
            } else {
                let userId = this.students[this.userIndex].id;
                try {
                    const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.changePassword + userId + "?newPassword=" + btoa(this.password),
                        {
                        },
                        {
                            headers: {
                                'X-Authorization': localStorage.getItem('token'),
                            },
                        },
                    );
                    console.log(response);
                    if (response.status == 200) {
                        alert("تم تغيير الرقم السري بنجاح!");
                        this.closePopup();
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        },
        async submitDetiles() {
           // send exactly editStudent payload to the correct endpoint
           const u = this.editStudent;
           try {
             await axios.put(
               process.env.VUE_APP_SERVICE_URL + url.update_student_details + u.id ,
               {
                 fullName:            u.fullName,
                 email:               u.email,
                 phone:               u.phone,
                 engagementPreference:u.engagementPreference,
                 qualificationId:     u.qualificationId,
                 user_preference: u.user_preference,
                 massaratId:          u.massaratId,
                 nationalId:          u.nationalId || null,
               },
               { headers: { 'X-Authorization': localStorage.getItem('token') } }
             );
             alert("تم حفظ التعديلات بنجاح!");
             this.closePopup();
             this.getAllNewStudents();
           } catch (error) {
             console.error(error);
             alert("فشل تغيير البيانات.");
           }
         },
        validatePassword() {
            // Reset error messages
            this.passwordError = '';
            this.confirmPasswordError = '';

            const specialCharRegex = /[@#!]/i;
            const uppercaseRegex = /[A-Z]/;
            const lowercaseRegex = /[a-z]/;
            const numberRegex = /[0-9]/;

            if (specialCharRegex.test(this.password) && uppercaseRegex.test(this.password) &&
                lowercaseRegex.test(this.password) && numberRegex.test(this.password)) {
                if (this.password !== this.confirmPassword && this.confirmPassword) {
                    this.confirmPasswordError = 'كلمة المرور غير متطابقة';
                    this.passwordSuccess = true;
                }
                else {
                    this.passwordSuccess = false;
                }
            } else if (this.password) {
                this.passwordError =
                    'الرقم السري يجب أن يكون بين 8 و 15 حرفا, الرقم السري يجب أن يكون مكون من علامة مميزة مثل "@#!" , يجب أن تحتوي كلمة المرور على أحرف كبيرة و صغيرة';
                this.passwordSuccess = true;
            }
        },
        validateEmail() {
            // Regular expression for basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email) && this.email.length != 0) {
                this.emailError = "الرجاء ادخال الايميل بشكل صحيح";
            } else {
                this.emailError = "";
            }
        },
        changeSessionsId(masterSessionValue) {
            this.sessionsId = this.masterSessionsList[masterSessionValue - 1].sessionsId;
            console.log(this.sessionsId);
        },
        getMasterSessions() {
            axios.get(process.env.VUE_APP_SERVICE_URL + url.master_sessions, {
                headers: {
                    'X-Authorization': localStorage.getItem('token'),
                }
            },)
                .then(response => {
                    this.masterSessionsList = response.data.result.data.map(data => new masterSessionsDto(data));
                    this.masterSessionValue = this.masterSessionsList[0].id;
                    this.sessionsId = this.masterSessionsList[0].sessionsId;
                    this.getAllNewStudents();
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });
        },
        handleSearch() {
            this.currentPage = 0;
            this.getAllNewStudents();
        },
        clearSearch() {
            this.searchQuery = '';
            this.currentPage = 0;
            this.getAllNewStudents();
        },
        handleFilterChange() {
            this.currentPage = 0;
            this.getAllNewStudents();
        },
        previousPage() {
            if (this.currentPage > 0) {
                this.currentPage--;
                this.getAllNewStudents();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
                this.getAllNewStudents();
            }
        },
        goToPage(page) {
            this.currentPage = page - 1;
            this.getAllNewStudents();
        },
        updateVisiblePages() {
            const maxVisiblePages = 5;
            const totalPages = this.totalPages;
            const currentPage = this.currentPage + 1; // Convert to 1-based
            
            let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            let end = Math.min(totalPages, start + maxVisiblePages - 1);
            
            if (end - start + 1 < maxVisiblePages) {
                start = Math.max(1, end - maxVisiblePages + 1);
            }
            
            this.visiblePages = [];
            for (let i = start; i <= end; i++) {
                this.visiblePages.push(i);
            }
        },
        openStudentDetailsModal(index) {
            this.selectedStudent = this.students[index];
            this.selectedStudentIndex = index;
            this.showStudentDetailsModal = true;
        },
        closeStudentDetailsModal() {
            this.showStudentDetailsModal = false;
            this.selectedStudent = null;
            this.selectedStudentIndex = null;
        },
        openEditModalFromDetails() {
            // Preserve index before closing details modal
            const index = this.selectedStudentIndex;
            this.closeStudentDetailsModal();
            this.openEditModal(index);
        },
        openPasswordModalFromDetails() {
            // Preserve index before closing details modal
            const index = this.selectedStudentIndex;
            this.closeStudentDetailsModal();
            this.openPopupPassword(index);
        },
        formatDate(dateString) {
            if (!dateString || dateString === null || dateString === undefined || dateString === '') {
                return '-';
            }
            try {
                // Handle different date formats
                let date;
                if (typeof dateString === 'string') {
                    // Try parsing the date string
                    date = new Date(dateString);
                } else if (dateString instanceof Date) {
                    date = dateString;
                } else {
                    return '-';
                }
                
                // Check if date is valid
                if (isNaN(date.getTime())) {
                    console.warn('Invalid date:', dateString);
                    return '-';
                }
                
                // Format as YYYY-MM-DD with 12-hour time format (ص/م)
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                
                // Convert to 12-hour format
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                const ampm = hours >= 12 ? 'م' : 'ص';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                const hours12 = String(hours).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours12}:${minutes}:${seconds} ${ampm}`;
            } catch (e) {
                console.error('Error formatting date:', dateString, e);
                return dateString || '-';
            }
        },
        openQuranPartsModal(student) {
            this.selectedStudentQuranParts = student.quranParts || [];
            this.selectedStudentName = student.fullName || '';
            this.showQuranPartsModal = true;
        },
        closeQuranPartsModal() {
            this.showQuranPartsModal = false;
            this.selectedStudentQuranParts = [];
            this.selectedStudentName = '';
        },
        openExportModal() {
            this.exportError = '';
            this.exporting = false;
            this.exportProgress = { done: 0, total: 0 };
            this.exportScope = 'filtered';
            this.exportSelectedFields = EXPORT_FIELDS.filter(f => f.default).map(f => f.key);
            this.showExportModal = true;
        },
        closeExportModal() {
            if (this.exporting) {
                return;
            }
            this.showExportModal = false;
            this.exportError = '';
        },
        selectAllExportFields() {
            this.exportSelectedFields = EXPORT_FIELDS.map(f => f.key);
        },
        clearExportFields() {
            this.exportSelectedFields = [];
        },
        // Same filter params the table itself uses, so the export always matches what the admin sees.
        buildExportParams() {
            const params = {
                isNew: this.isNewFilter,
                isDeactivated: this.isDeactivatedFilter,
                sessionId: null,
            };
            if (this.searchQuery && this.searchQuery.trim() !== '') {
                params.search = this.searchQuery.trim();
            }
            return params;
        },
        // Pages through get-students in chunks rather than requesting one huge page:
        // the backend resolves some relations per row, so a single giant page is costly.
        async fetchAllStudentsForExport() {
            const CHUNK = 200;
            const MAX_CHUNKS = 100; // safety cap: 20,000 students
            const baseParams = this.buildExportParams();
            const collected = [];

            for (let page = 0; page < MAX_CHUNKS; page++) {
                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + url.get_all_students, {
                    params: { ...baseParams, page, size: CHUNK },
                    headers: {
                        'X-Authorization': localStorage.getItem('token'),
                    },
                });

                const responseData = response.data.result.data;
                const content = responseData.content || [];
                content.forEach(studentData => collected.push(new StudentDto(studentData)));

                this.exportProgress = {
                    done: collected.length,
                    total: responseData.totalElements || collected.length,
                };

                if (!responseData.hasNext || content.length === 0) {
                    return collected;
                }
            }

            this.exportError = `تم تصدير أول ${collected.length} دارس فقط، الرجاء تضييق نطاق البحث.`;
            return collected;
        },
        async runExport() {
            if (this.exportSelectedFields.length === 0) {
                this.exportError = 'الرجاء اختيار حقل واحد على الأقل';
                return;
            }

            this.exportError = '';
            this.exporting = true;

            try {
                let list;
                if (this.exportScope === 'page') {
                    list = this.students;
                    this.exportProgress = { done: list.length, total: list.length };
                } else {
                    list = await this.fetchAllStudentsForExport();
                }

                if (!list || list.length === 0) {
                    this.exportError = 'لا توجد بيانات للتصدير';
                    return;
                }

                // Iterate the catalogue (not the click order) so columns are always in a stable order.
                const cols = EXPORT_FIELDS.filter(f => this.exportSelectedFields.includes(f.key));
                const headers = cols.map(f => f.label);
                const rows = list.map(student => {
                    const row = {};
                    cols.forEach(f => { row[f.label] = f.value(student); });
                    return row;
                });

                const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
                ws['!cols'] = cols.map(f => ({ wch: f.key === 'quranParts' ? 40 : 18 }));

                const wb = XLSX.utils.book_new();
                // RTL must be set on the workbook views; a worksheet-level '!views' is ignored by this version.
                wb.Workbook = { Views: [{ RTL: true }] };
                XLSX.utils.book_append_sheet(wb, ws, 'الدارسين');

                const out = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([out], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                saveAs(blob, `الدارسين_${new Date().toISOString().slice(0, 10)}.xlsx`);

                if (!this.exportError) {
                    this.showExportModal = false;
                }
            } catch (error) {
                console.error('Error exporting students', error);
                this.exportError = 'حدث خطأ أثناء التصدير، الرجاء المحاولة مرة أخرى.';
            } finally {
                this.exporting = false;
            }
        },
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Tailwind utility classes for enabled and disabled button states */
.enabled-button {
    @apply bg-customHafadhColor text-white rounded hover:bg-customHafadhColor;
    min-width: fit-content;
}

.disabled-button {
    @apply px-4 py-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed w-20 h-10;
}

.button-background {
    background: #679884;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 540px;
  text-align: center;
}

.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}
</style>